







(function () {
  function slidesPerView(slider) {
    var card = slider.querySelector('.review-card');
    if (!card) return 1;
    var per = Math.round(slider.clientWidth / card.getBoundingClientRect().width);
    return Math.max(1, per);
  }

  function pageCount(slider) {
    var cards = slider.querySelectorAll('.review-card').length;
    return Math.max(1, Math.ceil(cards / slidesPerView(slider)));
  }

  function currentPage(slider) {
    if (slider.scrollWidth <= slider.clientWidth) return 0;
    var ratio = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
    return Math.round(ratio * (pageCount(slider) - 1));
  }

  function paint(dots, index) {
    Array.prototype.forEach.call(dots.children, function (dot, i) {
      dot.classList.toggle('active', i === index);
      dot.querySelector('button').setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }

  function buildDots(panel) {
    var slider = panel.querySelector('[data-reviews-slider]');
    var dots = panel.querySelector('[data-reviews-dots]');
    if (!slider || !dots) return;

    var pages = pageCount(slider);
    dots.innerHTML = '';
    if (pages < 2) return;

    for (var i = 0; i < pages; i++) {
      var dot = document.createElement('li');
      dot.dataset.page = i;
      var button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', 'Show review page ' + (i + 1));
      dot.appendChild(button);
      dots.appendChild(dot);
    }
    paint(dots, currentPage(slider));

    if (slider.dataset.reviewsBound) return;
    slider.dataset.reviewsBound = '1';

    dots.addEventListener('click', function (event) {
      var dot = event.target.closest('li');
      if (!dot) return;
      var step = slider.scrollWidth - slider.clientWidth;
      var pagesNow = pageCount(slider) - 1;
      slider.scrollTo({
        left: pagesNow ? (Number(dot.dataset.page) / pagesNow) * step : 0,
        behavior: 'smooth',
      });
    });

    var ticking = false;
    slider.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        paint(dots, currentPage(slider));
        ticking = false;
      });
    }, { passive: true });
  }

  function initSection(section) {
    section.querySelectorAll('.tab-content').forEach(buildDots);

    section.querySelectorAll('.tab-btn').forEach(function (button) {
      if (button.dataset.reviewsBound) return;
      button.dataset.reviewsBound = '1';
      button.addEventListener('click', function () {
        var target = section.querySelector('#' + CSS.escape(button.dataset.tab));
        if (!target) return;

        section.querySelectorAll('.tab-btn').forEach(function (other) {
          var on = other === button;
          other.classList.toggle('active', on);
          other.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        section.querySelectorAll('.tab-content').forEach(function (panel) {
          panel.classList.toggle('active', panel === target);
        });


        buildDots(target);
      });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('.tabbed-reviews-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      document.querySelectorAll('.tab-content.active').forEach(buildDots);
    }, 150);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
